import {
    NgModule
} from '@angular/core';
import {
    ExportedClass as MarkdownModule
} from './custom/MarkdownModule';
@NgModule({
    declarations: [],
    imports: [],
    exports: [
        MarkdownModule,
    ]
})
export class CustomModulesModule {}